'use client';

import { Flex, Hide, Show } from '@chakra-ui/react';

import { useGiftcard } from 'context/giftcard';
import * as AppLayout from 'components/AppLayout';

import { Expired } from './components/Expired';
import { NotActivated } from './components/NotActivated';
import { Locked } from './components/Locked';

export const GiftcardStatusPage = () => {
  const { giftcard } = useGiftcard();

  const { isExpired, isActivated, isLocked, isFrozenFunds } = giftcard;

  return (
    <AppLayout.Root variant="error" data-testid="giftcard-status-page">
      <AppLayout.DesktopView />

      <AppLayout.MainView>
        <AppLayout.MainContainer>
          <AppLayout.NetworkLogo />

          <AppLayout.GiftcardAmount
            visibility={isLocked || isFrozenFunds ? 'hidden' : 'visible'}
          />

          <AppLayout.Main>
            {isExpired && <Expired />}

            {!isActivated && <NotActivated />}

            {(isLocked || isFrozenFunds) && <Locked />}

            <Show above="md" ssr>
              <AppLayout.GiftcardDescription giftcard={giftcard} />
            </Show>
          </AppLayout.Main>

          <Hide above="md" ssr>
            <Flex mt="3.25rem" px="1.5rem">
              <AppLayout.GiftcardDescription giftcard={giftcard} />
            </Flex>
          </Hide>
        </AppLayout.MainContainer>
      </AppLayout.MainView>
    </AppLayout.Root>
  );
};
